import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {ErrorModule} from "../errors/error.module";
import {FormHelpersModule} from "../form-helpers/form-helpers.module";
import {MdProgressSpinnerModule} from "../misc/progress-spinner";
import {AppSettingsModule} from "../app-settings/app-settings.module";
import {SmartsheetService} from "./smartsheet.service";
import {SmartsheetWorkspaceListDialogComponent} from "./smartsheet-workspace-list.dialog.component";
import {PaginationModule} from "../pagination/pagination.module";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    FormHelpersModule,
    BootstrapModalModule,
    ErrorModule,
    ReactiveFormsModule,
    MdProgressSpinnerModule,
    AppSettingsModule,
    PaginationModule,
  ],
  providers: [
    DialogService,
    SmartsheetService,
  ],
  declarations: [
    SmartsheetWorkspaceListDialogComponent,
  ],
  exports: [
    SmartsheetWorkspaceListDialogComponent,
  ],
  entryComponents: [
    SmartsheetWorkspaceListDialogComponent,
  ],
})
export class SmartsheetModule {}
